// /web/src/consent/CookieSettingsModal.jsx
import React, { useEffect, useState } from "react";
import { useConsent } from "./ConsentContext";
import "./cookie.css";

const defaultValues = {
  essential: true,
  analytics: false,
  marketing: false,
};

export default function CookieSettingsModal() {
  const { prefs, setPrefs, settingsOpen, hideSettings } = useConsent();
  const [values, setValues] = useState(defaultValues);

  useEffect(() => {
    if (settingsOpen) {
      setValues({
        ...defaultValues,
        analytics: !!prefs.analytics,
        marketing: !!prefs.marketing,
      });
    }
  }, [prefs.analytics, prefs.marketing, settingsOpen]);

  if (!settingsOpen) return null;

  const toggle = (key) => {
    if (key === "essential") return;
    setValues((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleSave = (next) => {
    setPrefs(next);
    hideSettings();
  };

  return (
    <div
      className="pd-cookie-modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-label="Cookie settings"
      onClick={hideSettings}
    >
      <div className="pd-cookie-modal" onClick={(event) => event.stopPropagation()}>
        <h2 className="pd-h3">Cookie Settings</h2>
        <p className="pd-muted">
          Adjust your cookie preferences below. Essential cookies cannot be turned off.
        </p>

        <div className="pd-cookie-options">
          <div className="pd-cookie-row">
            <div>
              <strong>Essential</strong>
              <p className="pd-muted small">Required for Pebbledash to function correctly.</p>
            </div>
            <input type="checkbox" checked readOnly />
          </div>

          <div className="pd-cookie-row">
            <div>
              <strong>Analytics (Amplitude)</strong>
              <p className="pd-muted small">Helps us understand usage and improve performance.</p>
            </div>
            <input type="checkbox" checked={values.analytics} onChange={() => toggle("analytics")} />
          </div>

          <div className="pd-cookie-row">
            <div>
              <strong>Marketing</strong>
              <p className="pd-muted small">Used for product announcements and marketing insights.</p>
            </div>
            <input type="checkbox" checked={values.marketing} onChange={() => toggle("marketing")} />
          </div>
        </div>

        <div className="pd-cookie-modal-actions">
          <button
            type="button"
            className="pd-btn pd-btn--ghost"
            onClick={() => {
              const reset = { ...defaultValues };
              setValues(reset);
              handleSave(reset);
            }}
          >
            Reject optional
          </button>

          <button
            type="button"
            className="pd-btn pd-btn--primary"
            onClick={() => handleSave(values)}
          >
            Save choices
          </button>

          <button type="button" className="pd-btn pd-btn--ghost" onClick={hideSettings}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
